import { render } from "./krenova.vue?vue&type=template&id=57e1d34b"
import script from "./krenova.vue?vue&type=script&lang=js"
export * from "./krenova.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dinaskominfo/Documents/Project/Vue/Erida/eridaApp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog,QCard,QCardSection,QCardActions});qInstall(script, 'directives', {ClosePopup});
